// Signal emitted after any successful add/update-status so other components
// (or the section itself) can trigger a refetch. Same pattern as the other
// v2 sections' events.js files.
export const ADD_V2_REFRESH = "add-v2:refresh";

/**
 * Open an update sheet in the editor rail. Payload: `{ addiction }`.
 *
 * There is no matching ADD event and there never will be: the addiction list
 * is fixed at four server-seeded rows (Smoking / Alcohol / Drugs / Tobacco)
 * with no add-new or delete endpoint, so every sheet this rail opens is an
 * update of a record that already exists.
 */
export const ADD_V2_EDIT = "add-v2:edit";
